import React from 'react';

const LearningPageContent = ({ currentChunk, currentMicroChunk }) => {
  return (
    <div style={{ padding: '20px' }}>
      {/* Chunk Display (like chunks page) */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        padding: '15px 10px',
        gap: '12px',
        borderBottom: '1px solid #e5e7eb',
        marginBottom: '10px',
        backgroundColor: 'white'
      }}>
        <span style={{
          width: '12px',
          height: '12px',
          borderRadius: '50%',
          backgroundColor: '#E5E7EB'
        }}></span>
        <span style={{
          flex: 1,
          fontWeight: '600',
          color: '#374151',
          fontSize: '16px',
          textAlign: 'left'
        }}>
          {currentChunk?.title || 'Loading chunk...'}
        </span>
      </div>

      {/* Current Point (like chunks page points) */}
      <div style={{
        display: 'flex',
        alignItems: 'flex-start',
        padding: '12px 10px',
        gap: '12px',
        backgroundColor: '#f9fafb',
        marginBottom: '20px'
      }}>
        <span style={{
          fontSize: '14px',
          color: '#4b5563',
          textAlign: 'left',
          lineHeight: '1.4',
          whiteSpace: 'normal',
          wordBreak: 'break-word'
        }}>
          🔹 {currentMicroChunk?.content || 'Loading content...'}
        </span>
      </div>
    </div>
  );
};

export default LearningPageContent;